export const ScheduleMode = Object.freeze({
  FirstList: 1,
  Fair: 2,
})
